import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useSetLifecycleCompletedCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SetLifecycleCompletedCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleCompletedCommandV1: result.authorized,
		setLifecycleCompletedCommandV1: result.command,
		completedSetLifecycleCompletedCommandV1: result.completed,
		errorSetLifecycleCompletedCommandV1: result.error,
		invokeSetLifecycleCompletedCommandV1: result.invoke,
		invokingSetLifecycleCompletedCommandV1: result.invoking,
		succeedSetLifecycleCompletedCommandV1: result.succeed,
		validationErrorsSetLifecycleCompletedCommandV1: result.validationErrors,
		onSucceedSetLifecycleCompletedCommandV1: result.onSucceed,
	}
}

export function useSetLifecycleInProgressCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	startDate?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _startDate = isRef<any>(startDate) ? startDate : ref<any>((typeof startDate === 'function') ? startDate() : startDate)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		startDate: _startDate,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof startDate === 'function') { _startDate.value = startDate() }

			return new c.SetLifecycleInProgressCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _startDate.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleInProgressCommandV1: result.authorized,
		setLifecycleInProgressCommandV1: result.command,
		completedSetLifecycleInProgressCommandV1: result.completed,
		errorSetLifecycleInProgressCommandV1: result.error,
		invokeSetLifecycleInProgressCommandV1: result.invoke,
		invokingSetLifecycleInProgressCommandV1: result.invoking,
		succeedSetLifecycleInProgressCommandV1: result.succeed,
		validationErrorsSetLifecycleInProgressCommandV1: result.validationErrors,
		onSucceedSetLifecycleInProgressCommandV1: result.onSucceed,
	}
}

export function useSetLifecyclePausedCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SetLifecyclePausedCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSetLifecyclePausedCommandV1: result.authorized,
		setLifecyclePausedCommandV1: result.command,
		completedSetLifecyclePausedCommandV1: result.completed,
		errorSetLifecyclePausedCommandV1: result.error,
		invokeSetLifecyclePausedCommandV1: result.invoke,
		invokingSetLifecyclePausedCommandV1: result.invoking,
		succeedSetLifecyclePausedCommandV1: result.succeed,
		validationErrorsSetLifecyclePausedCommandV1: result.validationErrors,
		onSucceedSetLifecyclePausedCommandV1: result.onSucceed,
	}
}

export function useSetLifecycleProposalCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SetLifecycleProposalCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleProposalCommandV1: result.authorized,
		setLifecycleProposalCommandV1: result.command,
		completedSetLifecycleProposalCommandV1: result.completed,
		errorSetLifecycleProposalCommandV1: result.error,
		invokeSetLifecycleProposalCommandV1: result.invoke,
		invokingSetLifecycleProposalCommandV1: result.invoking,
		succeedSetLifecycleProposalCommandV1: result.succeed,
		validationErrorsSetLifecycleProposalCommandV1: result.validationErrors,
		onSucceedSetLifecycleProposalCommandV1: result.onSucceed,
	}
}

export function useSetLifecycleQualifiedCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SetLifecycleQualifiedCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleQualifiedCommandV1: result.authorized,
		setLifecycleQualifiedCommandV1: result.command,
		completedSetLifecycleQualifiedCommandV1: result.completed,
		errorSetLifecycleQualifiedCommandV1: result.error,
		invokeSetLifecycleQualifiedCommandV1: result.invoke,
		invokingSetLifecycleQualifiedCommandV1: result.invoking,
		succeedSetLifecycleQualifiedCommandV1: result.succeed,
		validationErrorsSetLifecycleQualifiedCommandV1: result.validationErrors,
		onSucceedSetLifecycleQualifiedCommandV1: result.onSucceed,
	}
}

export function useSetLifecycleRejectedCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SetLifecycleRejectedCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleRejectedCommandV1: result.authorized,
		setLifecycleRejectedCommandV1: result.command,
		completedSetLifecycleRejectedCommandV1: result.completed,
		errorSetLifecycleRejectedCommandV1: result.error,
		invokeSetLifecycleRejectedCommandV1: result.invoke,
		invokingSetLifecycleRejectedCommandV1: result.invoking,
		succeedSetLifecycleRejectedCommandV1: result.succeed,
		validationErrorsSetLifecycleRejectedCommandV1: result.validationErrors,
		onSucceedSetLifecycleRejectedCommandV1: result.onSucceed,
	}
}

export function useSetLifecycleResumedCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SetLifecycleResumedCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleResumedCommandV1: result.authorized,
		setLifecycleResumedCommandV1: result.command,
		completedSetLifecycleResumedCommandV1: result.completed,
		errorSetLifecycleResumedCommandV1: result.error,
		invokeSetLifecycleResumedCommandV1: result.invoke,
		invokingSetLifecycleResumedCommandV1: result.invoking,
		succeedSetLifecycleResumedCommandV1: result.succeed,
		validationErrorsSetLifecycleResumedCommandV1: result.validationErrors,
		onSucceedSetLifecycleResumedCommandV1: result.onSucceed,
	}
}

export function useSetLifecycleScheduledCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	startDate?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _startDate = isRef<any>(startDate) ? startDate : ref<any>((typeof startDate === 'function') ? startDate() : startDate)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		startDate: _startDate,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof startDate === 'function') { _startDate.value = startDate() }

			return new c.SetLifecycleScheduledCommandV1(_workspaceId.value, _portfolioId.value, _id.value, _startDate.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleScheduledCommandV1: result.authorized,
		setLifecycleScheduledCommandV1: result.command,
		completedSetLifecycleScheduledCommandV1: result.completed,
		errorSetLifecycleScheduledCommandV1: result.error,
		invokeSetLifecycleScheduledCommandV1: result.invoke,
		invokingSetLifecycleScheduledCommandV1: result.invoking,
		succeedSetLifecycleScheduledCommandV1: result.succeed,
		validationErrorsSetLifecycleScheduledCommandV1: result.validationErrors,
		onSucceedSetLifecycleScheduledCommandV1: result.onSucceed,
	}
}

export function useSetLifecycleTerminatedCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SetLifecycleTerminatedCommandV1(_workspaceId.value, _portfolioId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSetLifecycleTerminatedCommandV1: result.authorized,
		setLifecycleTerminatedCommandV1: result.command,
		completedSetLifecycleTerminatedCommandV1: result.completed,
		errorSetLifecycleTerminatedCommandV1: result.error,
		invokeSetLifecycleTerminatedCommandV1: result.invoke,
		invokingSetLifecycleTerminatedCommandV1: result.invoking,
		succeedSetLifecycleTerminatedCommandV1: result.succeed,
		validationErrorsSetLifecycleTerminatedCommandV1: result.validationErrors,
		onSucceedSetLifecycleTerminatedCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectActivePlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectPlanId?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectPlanId = isRef<string>(projectPlanId) ? projectPlanId : ref<string>((typeof projectPlanId === 'function') ? projectPlanId() : projectPlanId)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		id: _id,
		projectPlanId: _projectPlanId,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectPlanId === 'function') { _projectPlanId.value = projectPlanId() }

			return new c.UpdateProjectActivePlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _id.value, _projectPlanId.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectActivePlanCommandV1: result.authorized,
		updateProjectActivePlanCommandV1: result.command,
		completedUpdateProjectActivePlanCommandV1: result.completed,
		errorUpdateProjectActivePlanCommandV1: result.error,
		invokeUpdateProjectActivePlanCommandV1: result.invoke,
		invokingUpdateProjectActivePlanCommandV1: result.invoking,
		succeedUpdateProjectActivePlanCommandV1: result.succeed,
		validationErrorsUpdateProjectActivePlanCommandV1: result.validationErrors,
		onSucceedUpdateProjectActivePlanCommandV1: result.onSucceed,
	}
}

